import { nextDelay } from "app";
import { FadeIn } from "components/fade-in";
import { MetaInfo } from "components/meta-info";
import { Center, MainTitle } from "components/styles";
import { BasePage } from "pages/base-page";
import phoneOverlay from "images/iphone_overlay.svg";
import screenshot from "images/iphone_screenshot.jpg";
// @ts-ignore
import video from "images/video.mp4";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import styled from "styled-components";

const Centerer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 32px;
`;

const Body = styled.div`
    height: 850px;
    clear: both;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const VideoContainer = styled.div`
    position: absolute;
    height: 700px;
`;

const PhoneOverlay = styled.div`
    position: absolute;
    top: 21px;
    left: 0px;
    transform: scale(1.118);
`;

const VideoWrapper = styled.div`
    border-radius: 50px;
    overflow: hidden;
`;

export const Home = () => {
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        const videoElement = document.createElement('video');
        videoElement.src = video;

        videoElement.addEventListener('loadeddata', () =>
            setInitialized(true)
        );

        videoElement.addEventListener('error', () =>
            setInitialized(true)
        );
    }, []);

    return <>
        <MetaInfo
            title="Magic AI Booth"
            description="Magic AI Booth"
            image={screenshot}
            imageW={1206}
            imageH={2662}
            path="/" />
        <BasePage>
            <Body>
                <MainTitle className="mb-4">
                    <FadeIn nextDelay={nextDelay}>
                        Magic AI Booth
                    </FadeIn>
                </MainTitle>

                <a href="https://apps.apple.com/app/id6740565744" target="_blank" rel="noopener noreferrer">
                    <img
                        src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                        alt="Download on the App Store"
                        width={300}
                        height={80} // Adjust size as needed
                    />
                </a>
                <FadeIn nextDelay={nextDelay}>
                    <Centerer>
                        <VideoContainer>
                            <VideoWrapper>
                                {initialized ? <video width="320" src={video} autoPlay muted playsInline /> : <Center><Spinner animation="border" /></Center>}
                            </VideoWrapper>
                            <PhoneOverlay>
                                <img src={phoneOverlay} alt="screenshot" />
                            </PhoneOverlay>
                        </VideoContainer>
                    </Centerer>
                </FadeIn>
            </Body>
        </BasePage>
    </>;
}
